// Password validation utility
export const validatePassword = (password) => {
  const errors = [];
  
  if (password.length < 8) {
    errors.push('at least 8 characters');
  }
  if (!/[a-z]/.test(password)) {
    errors.push('lowercase letter');
  }
  if (!/[A-Z]/.test(password)) {
    errors.push('uppercase letter');
  }
  if (!/[0-9]/.test(password)) {
    errors.push('number');
  }
  if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
    errors.push('special character');
  }
  
  return {
    isValid: errors.length === 0,
    errors: errors,
    message: errors.length > 0 
      ? `Password must contain: ${errors.join(', ')}` 
      : 'Password is strong'
  };
};
